import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/line-break}
 * @internal
 */
export default Longhand.fromKeywords({ inherits: true }, "auto", "loose", "normal", "strict", "anywhere");
//# sourceMappingURL=line-break.js.map